import { render } from "./customPagination.vue?vue&type=template&id=266e1899&scoped=true"
import script from "./customPagination.vue?vue&type=script&lang=js"
export * from "./customPagination.vue?vue&type=script&lang=js"

import "./customPagination.vue?vue&type=style&index=0&id=266e1899&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266e1899"]])

export default __exports__